export const STARTUP_PACKAGES = [
    'SU-199',
    'SU-399',
];
